import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';

import { useSessionCRUDActions } from '@mm/state/actions/SessionCRUDActions';
import InvitesController from '@mm/state/controllers/InvitesController';
import { StoreState } from '@mm/state/store-interfaces';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';
import { reset } from '@mm/state/actions/commonActions';

import * as commonRoutes from '../../../common/constants/routes';
import { parse, stringify } from 'query-string';
import { routes } from '../../../modules/LoginRouter/routes';
import Spinner from '../../../common/components/Spinner';

const { SIGNUP } = commonRoutes;

export const InvitePage = () => {
  const { inviteToken } = useParams<{ inviteToken: string }>();
  const history = useHistory();
  const { location } = history;

  const session = useSelector(selectSessionSelector);
  const dispatch: Dispatch<StoreState> = useDispatch();

  const sessionCRUDActions = useSessionCRUDActions();

  const handleToken = async () => {
    try {
      if (session) {
        dispatch(reset());
        await sessionCRUDActions.clear();
      }

      const { teamPricePlan, companyId, companyName, existingUser } =
        await InvitesController.validateInviteToken(inviteToken);

      sessionCRUDActions.setInviteToken(inviteToken, companyName);

      let path = existingUser
        ? routes.signin.compile()
        : routes.signup.compile();
      const query: Record<string, any> = {};

      if (companyName) {
        query.companyName = companyName;
      }

      if (teamPricePlan) {
        query.companyId = companyId;
      }

      if (Object.entries(query).length) {
        path = `${path}?${stringify(query)}`;
      }

      history.push(path);
    } catch (err) {
      const { companyId, ...rest } = parse(location.search);
      const q = stringify({
        ...rest,
        errorCode: err.errorCode,
      });
      history.push(SIGNUP + `?${q}`);
    }
  };

  useEffect(() => {
    handleToken();
  }, []);

  return <></>;
};
